import api from '@/utils/api'
import {Commit} from 'vuex'


const actions = {
  async api_file_mine_query_list(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileMetadata/urlList', params)
  },
  async api_file_mine_delete(_context: { commit: Commit }, params: any) {
    return api.post('/api/distribute/fileMetadata/deleteBatch', params)
  },
  async api_file_mine_generate_url(_context: { commit: Commit }, params: any) {
    return api.get('/api/distribute/fileMetadata/generate_download_url', {params})
  }
}

export default {
  actions
}
